import {Divider, Grid, Typography} from "@mui/material";
import {QuantityIngredientCollectionForm} from "../shared/QuantityIngredientCollectionForm";
import {
  fixedPriceUnitMap,
  FLOUR_EXCLUSION_UNITS,
  GENERAL_DRY_EXCLUSION_UNITS,
  LIQUID_EXCLUSION_UNITS, unitFpUnit,
  unitPounds
} from "../shared/Units";
import * as React from "react";
import {
  ingredientTypeGrain,
  ingredientTypeInclusion,
  ingredientTypeLiquid,
  ingredientTypeTopping
} from "../shared/Types";
import Button from "@mui/material/Button";
import RefreshIcon from '@mui/icons-material/Refresh';
import {sortOnStringField} from "../utils/ArrayUtils";

function CostForm(props) {
  const {costData, updateCostData, refreshCostDataIngredients} = props

  const grainCostData = costData.filter((i) => i.type === ingredientTypeGrain).sort((a,b) => sortOnStringField(a,b,'name'));
  const inclusionCostData = costData.filter((i) => i.type === ingredientTypeInclusion).sort((a,b) => sortOnStringField(a,b,'name'));
  const liquidCostData = costData.filter((i) => i.type === ingredientTypeLiquid).sort((a,b) => sortOnStringField(a,b,'name'));
  const toppingCostData = costData.filter((i) => i.type === ingredientTypeTopping).sort((a,b) => sortOnStringField(a,b,'name'));

  return (
    <Grid item container direction={'column'}>
      <div>
        <Grid item container direction={'row'}>
          <Button variant={'contained'} size={'small'} sx={{height: '3.25ch', marginTop: -1}} onClick={refreshCostDataIngredients}
            startIcon={<RefreshIcon/>}><Typography fontSize={12} marginTop={0.25}>Refresh</Typography> </Button>

        </Grid>
        <Divider textAlign={'right'} sx={{marginTop: 2, width: '90%'}}><Typography
                sx={{fontSize: 12, fontWeight: 350}}
                gutterBottom>Grain</Typography></Divider>
        {grainCostData?.length > 0 ? (
          <Grid item container direction={'column'} alignItems={'flex-start'} marginTop={1} marginBottom={1}>
            <QuantityIngredientCollectionForm ingredientData={grainCostData} setIngredientData={(data) => updateCostData(data, ingredientTypeGrain)}
                                              idField={'name'} nameField={'name'} unitField={'priceAmount'} unitFieldLabelOverride={'$ Price'}
                                              unitTypeField={'priceUnit'} defaultUnitType={unitPounds} collectionName={'Grain'}
                                              excludeUnits={FLOUR_EXCLUSION_UNITS} addDeleteDisabled={true} nameUpdateDisabled={true}/>
          </Grid> ) : null}
        <Divider textAlign={'right'} sx={{marginTop: 2, width: '90%'}}><Typography
                sx={{fontSize: 12, fontWeight: 350}}
                gutterBottom>Inclusions</Typography></Divider>
        {inclusionCostData?.length > 0 ? (
          <Grid item container direction={'column'} alignItems={'flex-start'} marginTop={1} marginBottom={1}>
            <QuantityIngredientCollectionForm ingredientData={inclusionCostData} setIngredientData={(data) => updateCostData(data, ingredientTypeInclusion)}
                                              idField={'name'} nameField={'name'} unitField={'priceAmount'} unitFieldLabelOverride={'$ Price'}
                                              unitTypeField={'priceUnit'} defaultUnitType={unitPounds} collectionName={'Inclusion'}
                                              excludeUnits={GENERAL_DRY_EXCLUSION_UNITS} addDeleteDisabled={true} nameUpdateDisabled={true}/>
          </Grid> ) : null}
        <Divider textAlign={'right'} sx={{marginTop: 2, width: '90%'}}><Typography
                sx={{fontSize: 12, fontWeight: 350}}
                gutterBottom>Liquid</Typography></Divider>
        {liquidCostData?.length > 0 ? (
          <Grid item container direction={'column'} alignItems={'flex-start'} marginTop={1} marginBottom={1}>
            <QuantityIngredientCollectionForm ingredientData={liquidCostData} setIngredientData={(data) => updateCostData(data, ingredientTypeLiquid)}
                                              idField={'name'} nameField={'name'} unitField={'priceAmount'} unitFieldLabelOverride={'$ Price'}
                                              unitTypeField={'priceUnit'} defaultUnitType={unitPounds} collectionName={'Liquid'}
                                              excludeUnits={LIQUID_EXCLUSION_UNITS} addDeleteDisabled={true} nameUpdateDisabled={true}/>
          </Grid> ) : null}
        <Divider textAlign={'right'} sx={{marginTop: 2, width: '90%'}}><Typography
                sx={{fontSize: 12, fontWeight: 350}}
                gutterBottom>Fixed Price Toppings</Typography></Divider>
          <Grid item container direction={'column'} alignItems={'flex-start'} marginTop={1} marginBottom={1}>
            <QuantityIngredientCollectionForm ingredientData={toppingCostData} setIngredientData={(data) => updateCostData(data, ingredientTypeTopping)}
                                              idField={'id'} nameField={'name'} unitField={'priceAmount'} unitFieldLabelOverride={'$ Price'}
                                              unitTypeField={'priceUnit'} defaultUnitType={unitFpUnit} collectionName={'Topping'}
                                              minCollectionSize={0} overrideUnits={fixedPriceUnitMap} />
          </Grid>
      </div>
    </Grid>
  )
}

export {CostForm}